function decodeFormSection(data = {}) {
  return {
    id: data.id,
    fields: (data.fields || []).map(x => x.key),
    title: data.label
  };
}

export default decodeFormSection;
